import { useContext } from 'react';

import { SplitConfigContext } from './SplitConfigContext';

export default function useSplitConfig() {
  const context = useContext(SplitConfigContext);

  if (!context) {
    throw new Error('useSplitConfig must be used within a SplitConfigProvider');
  }

  return context;
}
